import { render } from "./Folders.vue?vue&type=template&id=0dd42afe&ts=true"
import script from "./Folders.vue?vue&type=script&lang=ts"
export * from "./Folders.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__